<template>
  <div class="description">
    <div class="content">
      <div class="text">
        <h6>活动规则</h6>
        <p v-html="content.rule"></p>
        <h6>活动时间</h6>
        <p>{{ content.time }}</p>
      </div>
    </div>
    <div class="closeBtn" @click="closePage()">
      <van-icon name="cross" />
    </div>
  </div>
</template>

<script>
export default {
  name: "description",
  data() {
    return {
      content: {
        rule: "每轮答题将会从题库中随机抽取五道题进行作答。<br/> 参与者答对全部五题后，可进行抽奖，每人每天至多有三次抽奖机会，奖品数量有限，先到先得。",
        time: "9月14日——9月18日",
      },
    };
  },
  mounted() {},
  methods: {
    closePage() {
      this.$router.push({
        path: "/",
      });
    },
  },
};
</script>

<style lang="less" scoped>
.description {
  width: 100%;
  height: 100%;
  position: relative;
  .closeBtn {
    position: absolute;
    width: 8vw;
    height: 8vw;
    font-size: 5vw;
    border: 1px solid black;
    border-radius: 4vw;
    text-align: center;
    line-height: 9vw;
    background: #ffffff;
    bottom: 10vh;
    color: black;
    left: 46vw;
  }
  .content {
    position: absolute;
    top: 15vh;
    width: 100%;
    height: 115vw;
    background-image: url("../assets/hdsm.png");
    background-size: 100% 100%;
    .text {
      width: 56%;
      margin: 35vw auto;
      display: block;
      h6 {
        margin: 0;
        padding: 0;
        font-size: 6vw;
        color: #ff8b00;
      }
      p {
        color: #964221;
        font-size: 4vw;
        margin: 1vw 0;
        font-weight: 600;
      }
    }
  }
}
</style> 



// WEBPACK FOOTER //
// src/pages/description.vue